module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm4_m_en.9c81cf8e18fda78dd746ff7f46324364.png";